<template>
	<vs-popup
			:active.sync="show"
			title="Êtes-vous sûr de vouloir valider la supression?"
		>
			<div class="vx-row" style="z-index: 100 !important;">
				<div class="vx-col sm:w-1/2">
					<vs-button color="primary" class="mt-2 w-full" @click="accept()">Oui</vs-button>
				</div>
				<div class="vx-col sm:w-1/2">
					<vs-button color="primary" class="mt-2 w-full" @click="decline()">Non</vs-button>
				</div>
			</div>
		</vs-popup>
</template>

<script>
export default {
	name: "DeletePopup",
	props: {
		show: Boolean,
	},
	methods:
	{
		//emits the function "close-popup" //Don't forget to make one in parent compoonent//
		decline(){
			this.$emit("close-popup");
		},
		//emits the function "oui" //Don't forget to make one in parent compoonent//
		accept(){
			this.$emit("oui");
		},
	}
};
</script>